<template>
  <div class="h-screen flex items-start justify-center" role="status">
    <img :src="assetUrl('assets/gif/loading.gif')" alt="Escudo del Tolima" class="w-1/4 mr-2 h-auto">
    <span class="sr-only">Cargando...</span>
  </div>
</template>

<script>
import { assetUrl } from "@/common/constants";

/**
 Componente para mostrar una animación de carga.
 @component LoadingComponent
 */
export default {
  name: "LoadingComponent",
  methods: {
    assetUrl
  }
};
</script>